import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';

const VerificationBanner = () => {
  const { user, isAuthenticated } = useAuth();

  // Only show banner if user is logged in but not verified
  if (!isAuthenticated || !user || user.is_verified) {
    return null;
  }

  return (
    <div className="bg-yellow-500 text-black py-3 px-4">
      <div className="container mx-auto max-w-6xl">
        <div className="flex items-center justify-between flex-wrap gap-2">
          <div className="flex items-center gap-2">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
            </svg>
            <p className="text-sm font-medium">
              <strong>Email Not Verified:</strong> Please verify your email to upload videos and access all features.
            </p>
          </div>
          <div className="flex items-center gap-4">
{/*             <button */}
{/*               onClick={handleRefreshStatus} */}
{/*               disabled={refreshing} */}
{/*               className="text-sm font-semibold underline hover:no-underline whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed" */}
{/*             > */}
{/*               {refreshing ? 'Checking...' : 'Check Status'} */}
{/*             </button> */}
            <Link
              to="/resend-verification"
              className="text-sm font-semibold underline hover:no-underline whitespace-nowrap"
            >
              Resend Verification Email
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerificationBanner;
